import React, { ReactNode } from 'react'
import Popup from 'reactjs-popup'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
interface StyledPopupProps {
    width?: string
    children: ReactNode
    open: boolean
    closeOnDocumentClick: boolean
    onClose?: () => void
    overlayStyle?: React.CSSProperties
}
const StyledPopupContent = styled(Popup)<StyledPopupProps>`
    &-content {
        background: ${theme.newColors.neutral50};
        box-shadow:
            0px 8px 10px -5px rgba(0, 0, 0, 0.2),
            0px 16px 24px 2px rgba(0, 0, 0, 0.14),
            0px 6px 30px 5px rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        width: ${(props: StyledPopupProps) => (props.width ? props.width : '50%')}!important;
    }
    button {
        white-space: nowrap;
    }
`
const ModalStyledPopup: React.FC<StyledPopupProps> = ({ open, onClose, overlayStyle, children, ...props }) => {
    return (
        <StyledPopupContent open={open} onClose={onClose} overlayStyle={overlayStyle} closeOnEscape={false} {...props}>
            <>{children}</>
        </StyledPopupContent>
    )
}

export default ModalStyledPopup
